import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Copy, Check } from 'lucide-react';
import { BreadcrumbLink, BreadcrumbPage } from '@/components/ui/breadcrumb';
import { RenderIf } from '@/components/RenderIf';
import { EntityBreadcrumbProps } from './types';

const EntityBreadcrumb = ({
    label,
    entityId,
    entityType,
    href,
    isCurrentPage = false,
    isLoading = false,
}: EntityBreadcrumbProps) => {
    const [copied, setCopied] = useState(false);

    const handleCopyId = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();

        navigator.clipboard.writeText(entityId);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    const content = (
        <div className="flex items-center gap-2">
            <span>{label}</span>
            <RenderIf isTrue={!isLoading}>
                <button
                    onClick={handleCopyId}
                    className="p-1 hover:bg-gray-100 rounded transition-colors"
                    title={`Copy ${entityType} ID`}
                    type="button"
                >
                    <RenderIf isTrue={copied}>
                        <Check className="h-3 w-3 text-green-600" />
                    </RenderIf>
                    <RenderIf isTrue={!copied}>
                        <Copy className="h-3 w-3 text-gray-500" />
                    </RenderIf>
                </button>
            </RenderIf>
        </div>
    );

    return (
        <>
            <RenderIf isTrue={isCurrentPage === true}>
                <BreadcrumbPage>{content}</BreadcrumbPage>
            </RenderIf>
            <RenderIf isTrue={!isCurrentPage && !!href}>
                <BreadcrumbLink asChild>
                    <Link to={href!}>{content}</Link>
                </BreadcrumbLink>
            </RenderIf>
        </>
    );
};

export default EntityBreadcrumb;
